import { render, staticRenderFns } from "./BtRankingChart.vue?vue&type=template&id=ea5864ee&scoped=true&"
import script from "./BtRankingChart.vue?vue&type=script&lang=js&"
export * from "./BtRankingChart.vue?vue&type=script&lang=js&"
import style0 from "./BtRankingChart.vue?vue&type=style&index=0&id=ea5864ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5864ee",
  null
  
)

export default component.exports